import { useEffect, useState } from 'react';
import { isUnlocked, onUnlockChange } from '../utils/unlock';

// Reactive premium-unlock state; stays in sync across components
// when a payment completes anywhere in the app.
export const useUnlock = () => {
  const [unlocked, setUnlocked] = useState(isUnlocked);

  useEffect(() => onUnlockChange(() => setUnlocked(isUnlocked())), []);

  return unlocked;
};

export default useUnlock;
